import React from 'react';
import cx from 'classnames';

import styles from './layout.scss';

const CONTENT_SIZES = Object.freeze({
  big: 'big',
  container: 'container',
  full: 'full',
  large: 'large',
  middle: 'middle',
  narrow: 'narrow',
  none: 'none',
  small: 'small',
});

type ContentSize = typeof CONTENT_SIZES[keyof typeof CONTENT_SIZES];
type ClassName = Record<string, string> | string | null;

const ComponentsWrapper = ({
  children,
  className,
  selector: Selector = 'div',
  ...props
}: {
  children: React.ReactNode;
  className?: ClassName;
  selector?: 'div' | 'main' | 'section';
}) => (
  <Selector {...props} className={cx(styles.wrapper, className)}>
    {children}
  </Selector>
);

const ComponentContent = ({
  children,
  className,
  maxWidth,
  paddings = true,
  selector: Selector = 'div',
  ...props
}: {
  children: React.ReactNode;
  className?: ClassName;
  maxWidth?: ContentSize;
  paddings?: boolean;
  selector?: 'article' | 'aside' | 'div' | 'section';
}) => (
  <Selector {...props} className={
    cx(styles.content, styles[(maxWidth ?? CONTENT_SIZES.big)], className, { [styles.paddings]: paddings })
  }>
    {children}
  </Selector>
);

export { ComponentsWrapper, ComponentContent, CONTENT_SIZES };
